import { stateGo } from 'redux-ui-router';
import { email } from 'settings';
import { memberStorage } from 'utils';
import { fetchMember, selectMember } from 'logic/member';

import {
  setupChargifyError,
  fetchProducts,
  checkStatus,
  selectFieldsForGroup,
  selectProductsByType,
  selectProduct,
  selectProductBySlug,
  reset,
  restore,
  setup,
  signupSetVoomeProductId,
  update,
  updateChargifyData,
  verify,
} from '../logic/signup';

import {
  SIGNUP_FIELDS,
  SIGNUP_REDIRECT_URI,
  SIGNUP_TEXT,
  SIGNUP_TEXT_COUPON,
} from '../constants';

export const Signup = {
  template: `
    <div class="signup">
      <main class="main-content theme-mid pb-5">
        <div class="container align-items-center justify-content-center pt-4 pb-5"
          ng-switch="$ctrl.step">
          <div ng-switch-when="3">
            <signup-verifying>
              Verifying Payment
            </signup-verifying>
          </div>
          <div ng-switch-default>
            <header class="text-center mb-4">
              <h1 class="h2 text-blue-cz"
                ng-bind="$ctrl.text.title">
              </h1>
            </header>
            <section class="theme-light row">
              <div class="col-lg-8 offset-2">
                <div class="signup-content bg-white my-3 py-3 py-lg-5"
                  scroll-top-on-change="$ctrl.message">
                  <div class="px-3 px-md-5">
                    <alert type="danger" ng-show="$ctrl.message">
                      <span ng-bind-html="$ctrl.message"></span>
                    </alert>
                    <alert type="danger" ng-show="$ctrl.isDisabled">
                      Sorry team! Due to site maintenance, sign ups cannot be
                      accepted right now. Please try again in an hour.
                    </alert>
                    <alert type="info" ng-show="$ctrl.coupon === 'PROGRAM-UPGRADE'">
                      Thanks for choosing to upgrade, we just need to reconfirm your payment details.
                    </alert>
                  </div>
                  <div ng-hide="$ctrl.isDisabled">
                    <div class="px-3 px-md-5">
                      <signup-form-personal
                        is-disabled="$ctrl.step !== 1"
                        is-loading="$ctrl.isLoading"
                        chargify-data="$ctrl.chargifyData"
                        product="$ctrl.product"
                        text="$ctrl.text"
                        member="$ctrl.member"
                        on-update="$ctrl.updateChargifyData(key, value)"
                        on-submit="$ctrl.setup({
                          voomeProductId: $ctrl.product.id,
                          chargifyData: $ctrl.chargifyData,
                          coupon: $ctrl.coupon,
                          utmParams: $ctrl.utmParams,
                          campaignChannelMedium: $ctrl.campaignChannelMedium,
                        })">
                      </signup-form-personal>
                      <signup-form-billing
                        is-disabled="$ctrl.step !== 2"
                        is-loading="$ctrl.isLoading"
                        chargify-data="$ctrl.chargifyData"
                        chargify-fields="$ctrl.chargifyFields"
                        product="$ctrl.product"
                        text="$ctrl.text"
                        title="2. Billing Details"
                        on-cancel="$ctrl.onCancel()"
                        on-update="$ctrl.updateChargifyData(key, value)">
                      </signup-form-billing>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>`,

  controller($ngRedux, $window) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        // Set the fields to submit
        this.chargifyFields = SIGNUP_FIELDS;

        // Set the redirect
        this.updateChargifyData('redirectUri', SIGNUP_REDIRECT_URI);

        // Handle types/components
        const { currentState, currentParams } = $ngRedux.getState().router;

        // Does the coupon exist in SIGNUP_TEXT_COUPON
        const coupon = SIGNUP_TEXT_COUPON[currentParams.coupon]
          ? currentParams.coupon
          : undefined;

        // Google tracking tags
        this.utmParams = currentParams.utm_params;
        this.campaignChannelMedium = currentParams.campaign_channel_medium;
        // Fetch all products.
        this.fetchProducts(currentParams.coupon);

        // Get Member if applicable
        if (memberStorage.get().memberId) {
          this.fetchMember(memberStorage.get().memberId);
        }

        // Restore a previous signup.
        this.restore();

        // Wait for product before handling slug / coupon params
        if (currentParams.slug) {
          this.unsubscribe = $ngRedux.subscribe(() => this.onSubscribe());
        }

        switch (currentState.name) {
          case 'signupPrograms':
          case 'signupProgramsDetail':
          case 'signupProgram':
            this.handleSetupProgram(currentParams);
            break;

          case 'signup':
          case 'signupWeekly':
            this.handleSetupWeekly();
            break;

          case 'signupVerify':
            this.handleVerify(currentParams);
            break;
        }
      },

      $onDestroy() {
        this.disconnect();

        if (this.unsubscribe) {
          this.unsubscribe();
        }
      },

      onCancel() {
        $window.location.reload();
      },

      onSubscribe() {
        const { router, signup } = $ngRedux.getState();
        const { slug } = router.currentParams;

        // Preference coupon over slug
        const product = selectProductBySlug(signup, slug);

        if (product) {
          this.unsubscribe();
          this.update('voomeProductId', product.id);
        }
      },

      onChangeWeekly({ name }) {
        const { currentParams } = $ngRedux.getState().router;
        const slug =
          currentParams.slug === 'voome-bundle'
            ? name === 'Voome Workouts' ? 'voome-nutrition' : 'voome-workouts'
            : 'voome-bundle';

        this.stateGo('signupWeekly', { slug });
      },

      handleSetupProgram({ voomeProductId }) {
        this.checkStatus();
        this.update('type', 'program');

        if (voomeProductId) {
          this.hasDropdown = false;
          this.update('voomeProductId', voomeProductId);
        } else {
          this.hasDropdown = true;
        }
      },

      handleSetupWeekly() {
        this.checkStatus();
        this.update('type', 'weekly');
      },

      handleVerify(params) {
        params.status_code === '200'
          ? this.verify(params)
          : this.setupChargifyError(params);
      },

      mapState({ member, signup }) {
        const {
          isDisabled,
          isLoading,
          coupon,
          message,
          step,
          type,
          voomeProductId,
          chargifyData,
        } = signup;

        return {
          isDisabled,
          isLoading,
          coupon,
          message,
          step,
          type,
          chargifyData,
          member: selectMember(member),
          product: selectProduct(signup, voomeProductId),
          products: selectProductsByType(signup, type),
          text: coupon ? SIGNUP_TEXT_COUPON[coupon] : SIGNUP_TEXT[type],
        };
      },

      mapDispatch() {
        return {
          checkStatus,
          fetchMember,
          fetchProducts,
          reset,
          restore,
          setup,
          setupChargifyError,
          stateGo,
          update,
          updateChargifyData,
          verify,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Signup.js